var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{attrs:{"type":""},on:{"blur":_vm.onblur,"keyup":_vm.onkeyup},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }